import {useEffect} from 'react'

// Use in place of useEffect when we want the effect to only run once and
// useEffect would complain about exhaustive dependencies not being specified.
// eslint-disable-next-line react-hooks/exhaustive-deps
export const useMountEffect = (fn) => useEffect(fn, [])
